export const BRAZE_EVENTS = {
  log_in: 'logged_in',
  log_out: 'logged_out',
  on_site_check_in: 'on_site_check_in',
  page_view: 'page_view_pll_stats', //Adding stats to differentiate between web main & stats
  // Anonymous user events
  anonymous_session_start: 'anonymous_session_start',
  anonymous_to_identified: 'anonymous_to_identified',
}

//Analytics dash: https://www.notion.so/premierlacrosseleague/Analytics-Tags-Database-ca224c3268ec4c7c914c408b3e68b396?pvs=4
export const ANALYTICS_TAGS = {

  // GAME TICKER //
  boxscore_click: 'boxscore_click',
  preview_click: 'preview_click',
  ticket_click: 'ticket_click',

  // Player Comparison //
  page_view_stats_player_comparison: 'page_view_stats_player_comparison',

  // Login //
  login_click: 'login_click',
  phone_login_click: 'phone_login_click',
  email_login_click: 'email_login_click',
  google_login_click: 'google_login_click',
  login_cancelled: 'login_cancelled',

  // User //
  fav_team_click: 'fav_team_click',

  // SEASON //
  season_selection_change: 'season_selection_change',
  week_selection_change: 'week_selection_change',

  // VIDEO //
  video_start: 'video_start',
  video_watched: 'video_watched',
  video_click: 'video_click',

  // GENERAL //
  watch_click: 'watch_click', // clicking watch button on game tickers

  // SINGLE GAME //
  game_player_stats_tab_click: 'game_player_stats_tab_click',
  game_flow_goal_click: 'game_flow_goal_click',
  play_by_play_type_select: 'play_by_play_type_select',
  boxscore_highlight_click: 'boxscore_highlight_click',

  // STORAGE //
  storage_failure: 'storage_failure',

  // NAVIGATION //
  stats_nav_click: 'stats_nav_click',

  // NETWORK //
  network_request_failed: 'network_request_failed',

  // ADVANCED STATS //
  advanced_stats_category_selected: 'advanced_stats_category_selected',
  advanced_stats_year_change: 'advanced_stats_year_change',
  advanced_stats_min_touches_change: 'advanced_stats_min_touches_change',
  advanced_stats_table_sort: 'advanced_stats_table_sort',

  // FIREBASE //
  firebase_transaction_error: 'firebase_transaction_error',

  // PLAYER COMPARISON //
  player_comparison_select: 'player_comparison_select',
  player_comparison_clear: 'player_comparison_clear',
  player_comparison_swap: 'player_comparison_swap',
  player_comparison_position_filter: 'player_comparison_position_filter',
  player_comparison_error: 'player_comparison_error',

    // BRAZE //
    braze_setupBrazeSession: 'braze_setupBrazeSession',
    braze_subscription_cleanup_failed: 'braze_subscription_cleanup_failed',
    braze_provider_initialization_failed: 'braze_provider_initialization_failed',

  // SEARCH //
  search_click: 'search_click',
  search_tab_change: 'search_tab_change',

  //OTHER //
  app_callout_click: 'app_callout_click',
  player_leaders_avg_toggle_clicked: 'player_leaders_avg_toggle_clicked',

  // WEEK GAMES SLIDER //
  week_games_slider_card_click: 'week_games_slider_card_click',
}
